<template>
  <BButton class="button button-primary generic-button" :href="href">{{ text }}</BButton>
</template>

<script setup lang="ts">
import { BButton } from 'bootstrap-vue-next'

defineProps<{ href?: string; text?: string }>()
</script>

<style>
.generic-button { justify-content: center; width: 250px; }
</style>
